// AttendeesPickerSection — brief 84 band B, candidate B27.
// The invitees section the doodle and meeting dialogs rendered identically
// (~96%, six hunks, all one rename family: doodleDlg/setDoodleDlg vs
// mtgDlg/setMtgDlg — the props carry it, named after the donor's free
// identifiers). The third, smaller picker (the task modal's) diverges in 12
// hunks and stays in src/App.tsx, an orphaned survivor. _localizeGroup is
// declared once per dialog beside its old copy; each call site passes its
// own, and check 6e pins each to its own declaration.
import { ColleagueCheckGrid } from "./SharedUI";
import { FS } from "../lib/tokens";

export function AttendeesPickerSection({ doodleDlg, setDoodleDlg, t, _localizeGroup }: any) {
  return (
                    <div
                      style={{
                        borderTop: "1px solid var(--br)",
                        marginTop: 8,
                        paddingTop: 8,
                      }}
                    >
                      <label
                        style={{
                          fontSize: FS.s10,
                          fontWeight: 600,
                          color: "var(--tp)",
                          marginBottom: 6,
                          display: "block",
                        }}
                      >
                        {t("modal.attendees")}
                      </label>
                      {doodleDlg.internal ? (
                        <ColleagueCheckGrid
                          items={doodleDlg.attendees}
                          onToggle={(i: any) =>
                            setDoodleDlg((d: any) => ({
                              ...d,
                              attendees: d.attendees.map((x: any, j: any) =>
                                j === i ? { ...x, checked: !x.checked } : x,
                              ),
                            }))
                          }
                          onToggleAll={(next: any) =>
                            setDoodleDlg((d: any) => ({
                              ...d,
                              attendees: d.attendees.map((x: any) => ({
                                ...x,
                                checked: next,
                              })),
                            }))
                          }
                        />
                      ) : (
                      (() => {
                        const groups: Record<string, any[]> = {};
                        doodleDlg.attendees.forEach((a: any, i: any) => {
                          (groups[a.group] = groups[a.group] || []).push({
                            ...a,
                            idx: i,
                          });
                        });
                        return Object.entries(groups).map(
                          ([g, people]) =>
                            people.length > 0 && (
                              <div key={g} style={{ marginBottom: 6 }}>
                                <span
                                  style={{
                                    fontSize: FS.s9,
                                    color: "var(--tm)",
                                    textTransform: "uppercase",
                                    letterSpacing: ".3px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {_localizeGroup(g)}
                                </span>
                                {people.map((p) => (
                                  <label
                                    key={p.id}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 6,
                                      padding: "3px 0",
                                      fontSize: FS.s10_5,
                                      cursor: "pointer",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={p.checked}
                                      onChange={() =>
                                        setDoodleDlg((d: any) => ({
                                          ...d,
                                          attendees: d.attendees.map((x: any, j: any) =>
                                            j === p.idx
                                              ? { ...x, checked: !x.checked }
                                              : x,
                                          ),
                                        }))
                                      }
                                    />
                                    <span style={{ flex: 1 }}>{p.name}</span>
                                    <span
                                      style={{
                                        color: "var(--tm)",
                                        fontSize: FS.s9_5,
                                      }}
                                    >
                                      {p.email}
                                    </span>
                                  </label>
                                ))}
                              </div>
                            ),
                        );
                      })()
                      )}
                    </div>
  );
}
